import React, { useState, useEffect } from "react";
import { useAuth } from "../../hooks/GlobalProvider";
import {
  USER_CURRENCY,
  USER_WITHDRAWAL,
  CRUD_Withdrawal,
  FETCH_Users,
  user_referral_level_one,
  SettingsCRUD,
} from "../../hooks/APIHooks";
import { IoWallet } from "react-icons/io5";
import { CRUD_API_EDITPROFILE } from "../../hooks/APIHooks";
import { Link } from "react-router-dom";

const Withdraw = () => {
  const { user } = useAuth();
  const [digitalCurrency, setDigitalCurrency] = useState(null);
  const [amount, setAmount] = useState("");
  const [message, setMessage] = useState("");
  const [withdrawals, setWithdrawals] = useState([]);
  const [isFriday, setIsFriday] = useState(false);
  const [referrals, setReferrals] = useState([]);
  const [activeReferralCount, setActiveReferralCount] = useState(0);
  const [settings, setSettings] = useState(null);
const [bankDetailsFilled, setBankDetailsFilled] = useState(false);

  // Fetch settings
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(SettingsCRUD);
        const data = await response.json();
        setSettings(data);
      } catch (error) {
        console.error("Error fetching company settings:", error);
      }
    };
    fetchSettings();
  }, []);

  // Determine if withdrawal is allowed
  useEffect(() => {
    if (settings) {
      const allowAll = settings?.all_day_payments === "true";
      const today = new Date().getDay(); // 5 = Friday
      setIsFriday(allowAll || today === 5);
    }
  }, [settings]);

  // Fetch balance and withdrawal history
  useEffect(() => {
    if (!user?.user_id) return;

    
    fetch(USER_CURRENCY, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id: user.user_id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setDigitalCurrency(data.digital_currency);
      })
      .catch(console.error);

    fetch(CRUD_Withdrawal)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const userWithdrawals = data.withdrawals.filter(
            (w) => String(w.user_id) === String(user.user_id)
          );
          setWithdrawals(userWithdrawals);
        }
      })
      .catch(console.error);
  }, [user]);

  
useEffect(() => {
  if (!user?.user_id) return;

  const fetchBankDetails = async () => {
    try {
      const res = await fetch(`${CRUD_API_EDITPROFILE}?user_id=${user.user_id}`);
      const data = await res.json();
      if (res.ok) {
        const { bank_account_number, ifsc_code, bank_name } = data;
        setBankDetailsFilled(
          bank_account_number && ifsc_code && bank_name ? true : false
        );
      }
    } catch (err) {
      console.error("Error fetching bank details:", err);
      setBankDetailsFilled(false);
    }
  };

  fetchBankDetails();
}, [user]);

  // Fetch active referrals
  useEffect(() => {
    const fetchReferrals = async () => {
      try {
        const res = await fetch(FETCH_Users, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ role: user.role }),
        });
        const data = await res.json();

        const currentUser = data?.users?.find(
          (u) => u.phonenumber === user.phonenumber
        );
        if (!currentUser) return;

        const referralRes = await fetch(user_referral_level_one, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            reference_code: currentUser.reference_code,
          }),
        });

        const referralData = await referralRes.json();
        if (referralData.success) {
          setReferrals(referralData.referrals);
          setActiveReferralCount(
            referralData.referrals.filter((ref) => ref.pannel_access === "True")
              .length
          );
        }
      } catch (err) {
        console.error("Referral fetch error:", err);
      }
    };

    fetchReferrals();
  }, [user]);

  const handleWithdraw = () => {
    const parsedAmount = parseFloat(amount);
    if (!parsedAmount || parsedAmount < 500) {
      setMessage("Minimum withdrawal amount is ₹500");
      return;
    }

    if (parsedAmount > digitalCurrency) {
      setMessage(`Insufficient balance. Maximum you can withdraw is ₹${digitalCurrency}`);
      return;
    }

    fetch(USER_WITHDRAWAL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id: user.user_id, amount: parsedAmount }),
    })
      .then((res) => res.json())
      .then((data) => {
        setMessage(data.message);
        if (data.success) {
          setAmount("");
          setDigitalCurrency((prev) => parseFloat(prev) - parsedAmount);
          fetch(CRUD_Withdrawal)
            .then((res) => res.json())
            .then((data) => {
              if (data.success) {
                const userWithdrawals = data.withdrawals.filter(
                  (w) => String(w.user_id) === String(user.user_id)
                );
                setWithdrawals(userWithdrawals);
              }
            });
        }
      })
      .catch((err) => {
        setMessage("Request failed");
        console.error(err);
      });
  };

const areChainsBalanced = referrals.length >= 3 && 
  Number(referrals[0].reference_total) === Number(referrals[1].reference_total) && 
  Number(referrals[1].reference_total) === Number(referrals[2].reference_total);

const isWithdrawEnabled = isFriday && activeReferralCount >= 3 && bankDetailsFilled && areChainsBalanced;

  return (
    <div className="bg-primary-100 pt-2">
      <div className="w-full bg-secondary my-2 text-black overflow-hidden whitespace-nowrap py-1">
        <div className="inline-block animate-marquee font-semibold text-[14px]">
          Withdrawals will be opened on every Friday and you will receive
          payments within 48hr.
        </div>
      </div>

    

      <div className="bg-primary-100 py-1 px-4 min-h-screen">
        {/* Wallet */}
        <div className="mx-auto text-center mt-6 max-w-md">
          <div className="flex items-center justify-center gap-4 text-secondary">
            <IoWallet size={60} />
            <span className="text-4xl font-bold">
              ₹ {digitalCurrency !== null ? digitalCurrency : "Loading..."}
            </span>
          </div>

          {!bankDetailsFilled && (
  <p className="text-sm text-yellow-500 mt-1">
    Please <Link to="/settings" className="underline text-white  ">Fill your bank details</Link> to enable withdrawals.<Link to="/settings" className="underline text-white"> Click here</Link> 
  </p>
)}

          <div className="mt-4 space-y-2">
            <input
              type="number"
              className="border rounded p-2 w-full"
              placeholder="Enter withdrawal amount"
              value={amount}
              onChange={(e) => {
                const val = e.target.value;
                if (val === "") {
                  setAmount("");
                  return;
                }
                const numVal = parseFloat(val);
                if (digitalCurrency !== null && numVal > digitalCurrency) {
                  setAmount(digitalCurrency.toString());
                } else {
                  setAmount(val);
                }
              }}
              disabled={!isWithdrawEnabled}
            />
            <button
              onClick={handleWithdraw}
              className={`font-semibold px-4 py-2 rounded w-full transition-all duration-300 ${
                isWithdrawEnabled
                  ? "bg-secondary text-primary shadow-lg scale-[1.02]"
                  : "bg-gray-400 text-gray-600 cursor-not-allowed opacity-50"
              }`}
              disabled={!isWithdrawEnabled}
            >
              Request Withdrawal
            </button>
            {message && <div className="text-sm text-red-500 mt-2 font-medium">{message}</div>}
          </div>
        </div>


          {/* Withdrawal Conditions Section */}
      <div className="mt-2 w-full bg-primary rounded-xl p-4 text-white max-w-md mx-auto shadow-xl border border-white/10">
        <h3 className="text-lg font-bold mb-4 border-b border-white/20 pb-2 flex items-center justify-center gap-2">
           Withdrawal Requirements
        </h3>
        <div className="space-y-3">
          {/* Min Balance Condition */}
          <div className="flex justify-between items-center bg-white/5 p-3 rounded-lg border border-white/5">
            <span className="text-sm font-medium">Minimum Balance (₹500)</span>
            <span className={`text-[12px] font-bold px-2 py-1 rounded-full ${digitalCurrency >= 500 ? "bg-green-500/20 text-green-400" : "bg-red-500/20 text-red-400"}`}>
              {digitalCurrency >= 500 ? "✓ Met" : "✗ Not Met"}
            </span>
          </div>

          {/* Referral Condition */}
          <div className="flex justify-between items-center bg-white/5 p-3 rounded-lg border border-white/5">
            <span className="text-sm font-medium">Active Referrals (Min 3)</span>
            <span className={`text-[12px] font-bold px-2 py-1 rounded-full ${activeReferralCount >= 3 ? "bg-green-500/20 text-green-400" : "bg-red-500/20 text-red-400"}`}>
              {activeReferralCount >= 3 ? `✓ (${activeReferralCount})` : `✗ (${activeReferralCount}/3)`}
            </span>
          </div>

          {/* Chain Balance Condition */}
          <div className="flex justify-between items-center bg-white/5 p-3 rounded-lg border border-white/5">
            <span className="text-sm font-medium">Balanced Chains (A=B=C)</span>
            <span className={`text-[12px] font-bold px-2 py-1 rounded-full ${areChainsBalanced ? "bg-green-500/20 text-green-400" : "bg-red-500/20 text-red-400"}`}>
              {areChainsBalanced ? "✓ Balanced" : "✗ Unbalanced"}
            </span>
          </div>

          {/* Bank Details Condition */}
          <div className="flex justify-between items-center bg-white/5 p-3 rounded-lg border border-white/5">
            <span className="text-sm font-medium">Bank Details Status</span>
            <span className={`text-[12px] font-bold px-2 py-1 rounded-full ${bankDetailsFilled ? "bg-green-500/20 text-green-400" : "bg-red-500/20 text-red-400"}`}>
              {bankDetailsFilled ? "✓ Completed" : "✗ Incomplete"}
            </span>
          </div>
        </div>
      </div>

        {/* History */}
        <div className="mt-6 text-white text-center">
          <h2 className="text-lg font-bold">Payment History</h2>
          <p className="text-sm">All your previous payment history.</p>
        </div>

        <div className="max-w-md mx-auto bg-white p-4 mt-2 rounded shadow-md">
          <h2 className="text-lg font-bold">
            Previous Transactions
            <p className="text-[14px] font-normal text-gray-400">
              5% Handling Charges
            </p>
          </h2>

          {withdrawals.length === 0 ? (
            <p className="text-sm text-gray-500">No transactions found.</p>
          ) : (
            <ul className="divide-y divide-gray-200">
              {withdrawals.map((withdraw, idx) => {
                const status = withdraw.status?.toLowerCase();
                const statusColor =
                  status === "pending"
                    ? "text-yellow-600"
                    : status === "approved"
                    ? "text-blue-600"
                    : status === "completed"
                    ? "text-green-600"
                    : "text-red-600";

                return (
                  <li
                    key={withdraw.withdraw_id || idx}
                    className="py-2 text-sm"
                  >
                    <div className="grid grid-cols-3">
                      <span className="font-medium">
                        ₹ {withdraw.amount}
                        <p className="text-[10px] text-gray-800">
                          After Charges: ₹ {(withdraw.amount * 0.95).toFixed(2)}
                        </p>
                      </span>
                      <span className="truncate">
                        {withdraw.transaction_id || "-"}
                      </span>
                      <span className={`${statusColor} capitalize`}>
                        {status === "completed" ? "Success" : withdraw.status}
                      </span>
                    </div>
                    <div className="flex justify-between text-[10px] text-gray-400 mt-1">
                      <span>
                        Request:{" "}
                        {new Date(withdraw.requested_at).toLocaleString()}
                      </span>
                      <span>
                        Processed:{" "}
                        {new Date(withdraw.processed_at).toLocaleString()}
                      </span>
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default Withdraw;
